import { useContext, useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import utility from "src/utils/utility"
import ApiContext from "src/provider/API/call-service"
import { AppSpan, AppText, CustomContainer, FlexRow, PageTitle, PageWrapper } from "src/style"
import { IoIosArrowBack } from "react-icons/io"
import { walletFundingHistoryColumns, walletFundingHistoryData } from 'src/utils/table-layout'
import helpers from "src/utils/helpers"
import { Filter, ServerSideTable } from "src/component"

const WalletFundingHistory = () => {
    const navigate = useNavigate()
    const {API, downloadReport} = useContext(ApiContext)
    const [reportData, setReportData] = useState<any>(null)
    const [report, setReport] = useState<Array<any>|null>(null)
    const [resetPagination, setResetPagination] = useState<boolean>(false)
    const [view, setView] = useState('')

    const filterDataRef = useRef<any>({})

    useEffect(() => {
        filterDataRef.current = {}
        handleFetchReport()
    }, [])

    async function handleFetchReport (pageNumber = 1, pageSize = 10, isDownload = false) {
        const fetchPayload = { 
            pageNumber, pageSize, 
            ...filterDataRef.current, 
            filter: {...filterDataRef.current.filter},
            //returnMax: isDownload 
        }
        
        const response = {data: walletFundingHistoryData, total: 4}

        if (response) {
            if (isDownload) {
                return downloadReport(response, `WALLET_FUNDING_HISTORY_REPORT`)
            }

            //response.data = helpers.addSerialNumberToItems(response?.data, {pageNumber, pageSize})

            setReportData(response)
            setReport(response.data)
        }
    }

    function handleClear () {
        filterDataRef.current = {}
        handleFetchReport()
        setResetPagination(!resetPagination)
    }

    return (
        <>
            <PageWrapper>
                <FlexRow 
                    width="auto" sizeUnit="" gap="1"
                    onClick={() => navigate(-1)}
                >
                    <AppSpan textSize='2.5' cursor='pointer' bottomMargin='1' >
                        <IoIosArrowBack />
                    </AppSpan>
                    
                    <PageTitle 
                        color='#101828' textSize='3' fontWeight="500"
                    >
                        Wallet Funding History
                    </PageTitle>
                </FlexRow>
                <CustomContainer topMargin="2">
                    <ServerSideTable
                        tableData={report}
                        tableColumns={walletFundingHistoryColumns} 
                        dataFetchMethod={handleFetchReport}
                        totalRows={reportData?.totalRecords}
                        customStyle
                        shouldResetPagination={resetPagination}
                        canFilter={() => setView('filter')}
                        canClear={handleClear}
                        downloadAction={() => handleFetchReport(1, 10, true)}
                    />
                </CustomContainer>
            </PageWrapper>
            { view === 'filter' &&
                <Filter
                    type='wallet-funding-history'
                    onApplyFilter={handleFetchReport}
                    setFilterData={(data: any) => {filterDataRef.current = data}}
                    close={() => setView('')}
                />
            }
        </>
    )
}

export default utility.routeData('billing/wallet-funding-history', 'Wallet Funding History', <WalletFundingHistory/>)